import { AfterViewInit, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
	selector: '[detectTextTruncation]',
	exportAs: 'detectTextTruncation',
	standalone: true
})
export class DetectTextTruncationDirective implements AfterViewInit, OnDestroy {
	@Output() public truncatedChange = new EventEmitter<boolean>();

	private observer: ResizeObserver;
	private _truncated = false;

	constructor (private host: ElementRef<HTMLElement>) {
		this.observer = new ResizeObserver(() => this.checkTruncation());
	}

	public ngAfterViewInit (): void {
		this.checkTruncation();
		this.observer.observe(this.host.nativeElement);
	}

	public ngOnDestroy (): void {
		this.observer.disconnect();
	}

	private checkTruncation (): void {
		const el = this.host.nativeElement;
		const newValue = el.scrollWidth > el.clientWidth;

		if (newValue !== this._truncated) {
			this._truncated = newValue;
			this.truncatedChange.emit(newValue);
		}
	}
}
